// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c34baf2","239":"b2522453","455":"4547dd2d","884":"089fbd63"}[chunkId] + ".chunk.js";
};